import urls from "./urls";

export default {
    APP_VERSION: 3,
    LATEST_FEATURE: "FLASHCARDS",
    STRIPE_API_PUBLIC_KEY: "pk_live_51L9xGDFlB6ahBIg1yN5FJBEZICOEaBkZ8sTwKHZT5Nnk1P95IhHUOHfyG2ijzA7CgDRdp99Xn0pYOYVcyObfaykM00oIZCCMnC",
    // STRIPE_API_PUBLIC_KEY: "pk_test_51L9xGDFlB6ahBIg1KxQlGmYVpYRsA4E3vuriJFWrC7wkqErFNmG734dSYVYkUoq3XqjcsmNQrKIKMF6mwQYY9U5h00U7MHe7ur",
    SHARE_APP_DATA: data => {
        return {
            title: "SchoolDiary",
            text: "Installa anche tu SchoolDiary, il diario digitale condiviso con la tua classe!",
            url: `${urls.base}/login?school=${data.school}&class=${data.class}`
        }
    },
    EVENTS_FILTER_FOR_YOU: "events_filter_for_you",
    EVENTS_FILTER_ALL: "events_filter_all",
    WORKER_QUERIES: {
        "GENERATE_CALENDAR": "GENERATE_CALENDAR",
    }
};